import React from 'react';
import FormBlock from './FormBlock';
import { Controller, UseFormSetValue, UseFormTrigger } from 'react-hook-form';
import { ComboboxNamHoc } from '../../../components/combobox-namhoc';
import { IHocSinh } from '../../../models/response/crm-hocsinh/IHocsinh';
import { crmHocSinhApi } from '../../../api/crmHocSinhApi';
import { Box, FormControl } from '@primer/react';
import TextInput from '../../../components/ui/text-input';
import StyledDatePicker from '../../../components/react-datepicker-style/ReactDatePicker';
import ComboboxGioiTinh from '../../../components/combobox-gioitinh';
import ComboboxDanToc from '../../../components/combobox-dantoc';
import ComboboxTonGiao from '../../../components/combobox-tongiao';
import ComboboxQuocTich from '../../../components/combobox-quoctich';
import { ComboboxTrangThaiHocSinh } from '../../../components/combobox-trangthaihocsinh';
interface IThongTinHocSinhProps {
    control: any,
    hocSinh: IHocSinh,
    setFormData: React.Dispatch<React.SetStateAction<IHocSinh>>,
    setValue: UseFormSetValue<IHocSinh>,
    generatedCode?: string,
    register: any,
    errors: any,
    formData: IHocSinh,
    trigger: UseFormTrigger<IHocSinh>

}
const ThongTinHocSinh = (props: IThongTinHocSinhProps) => {
    const { control, setFormData, hocSinh, setValue, generatedCode, register, errors, formData, trigger } = props;
    return (
        <FormBlock caption='Thông tin học sinh'>
            <Box sx={{
                display: "grid",
                gap: 2
            }}>
                <Box sx={{
                    display: "grid",
                    gap: 2,
                    gridTemplateColumns: "repeat(5, minmax(200px, 1fr))"
                }}>
                    <Controller
                        name="nam_hoc"
                        control={control as any} // hoặc khai báo kiểu cụ thể
                        rules={{ required: "Vui lòng chọn năm học" }}
                        render={({ field }) => (
                            <FormControl>
                                <FormControl.Label>
                                    Năm học
                                </FormControl.Label>
                                <ComboboxNamHoc
                                    value={field.value}
                                    onValueChanged={async (value) => {
                                        field.onChange(value);
                                        setFormData((prev) => ({
                                            ...prev,
                                            nam_hoc: value,
                                        }));

                                        // Kiểm tra có phải đang edit không
                                        if (hocSinh.id > 0) {
                                            try {
                                                const res = await crmHocSinhApi.getHSCCById(
                                                    hocSinh.id,
                                                    value
                                                );
                                                if (res.is_success && res.data) {
                                                    // Cập nhật các giá trị từ API
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        dm_truong_id: res.data.dm_truong_id || 0,
                                                        dm_khoi_id: res.data.dm_khoi_id || 0,
                                                        dm_he_id: res.data.dm_he_id || 0,
                                                        dm_lop_id: res.data.dm_lop_id || 0,
                                                        dm_trangthaihocsinh_id:
                                                            res.data.dm_trangthaihocsinh_id || 0,
                                                    }));

                                                    const defaultValues = {
                                                        dm_truong_id: res.data.dm_truong_id || 0,
                                                        dm_khoi_id: res.data.dm_khoi_id || 0,
                                                        dm_he_id: res.data.dm_he_id || 0,
                                                        dm_lop_id: res.data.dm_lop_id || 0,
                                                        dm_trangthaihocsinh_id:
                                                            res.data.dm_trangthaihocsinh_id || 0,
                                                    };

                                                    Object.entries(defaultValues).forEach(
                                                        ([key, value]) => {
                                                            setValue(key as keyof IHocSinh, value);
                                                        }
                                                    );
                                                } else {
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        dm_truong_id: 0,
                                                        dm_khoi_id: 0,
                                                        dm_he_id: 0,
                                                        dm_lop_id: 0,
                                                        dm_trangthaihocsinh_id: 0,
                                                    }));

                                                    // Reset form values
                                                    const defaultValues = {
                                                        dm_truong_id: 0,
                                                        dm_khoi_id: 0,
                                                        dm_he_id: 0,
                                                        dm_lop_id: 0,
                                                        dm_trangthaihocsinh_id: 0,
                                                    };

                                                    Object.entries(defaultValues).forEach(
                                                        ([key, value]) => {
                                                            setValue(key as keyof IHocSinh, value);
                                                        }
                                                    );
                                                }
                                            } catch (error) {
                                                console.error("Error fetching data:", error);
                                            }
                                        }
                                    }}
                                />
                            </FormControl>
                        )}
                    />
                     <FormControl>
                        <FormControl.Label>Mã KH</FormControl.Label>
                        <TextInput
                            block
                            name="ma_kh"
                            register={register}
                            errors={errors}
                            required={false}
                        />
                    </FormControl>
                    <Controller
                        name="ma_hs"
                        control={control}
                        render={({ field }) => (
                            <FormControl>
                                <FormControl.Label>Mã học sinh</FormControl.Label>
                                <TextInput
                                    block
                                    {...field}
                                    // value={hocSinh.id === 0 ? generatedCode : field.value || ""}
                                    value={field.value || ""}
                                    onChange={(event) => {
                                        field.onChange(event.target.value);

                                    }}
                                    // disabled={true} // Luôn disable mã học sinh
                                    // placeholder={hocSinh.id === 0 ? (generatedCode || "Đang sinh mã...") : ""}
                                />
                            </FormControl>
                        )}
                    />
                    <FormControl>
                        <FormControl.Label>Họ tên (Vi)</FormControl.Label>
                        <TextInput
                            block
                            name="ho_ten"
                            register={register}
                            errors={errors}
                            required
                            validateMessage="Vui lòng điền họ tên tiếng Việt"
                        />
                    </FormControl>
                    <FormControl>
                        <FormControl.Label>Họ tên (En)</FormControl.Label>
                        <TextInput
                            block
                            name="ho_ten_en"
                            register={register}
                            errors={errors}
                            // required
                            // validateMessage="Vui lòng điền họ tên tiếng Anh"
                        />
                    </FormControl>


                </Box>
                <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: "repeat(4,1fr)" }}>
                    <FormControl>
                        <FormControl.Label>Ngày sinh</FormControl.Label>
                        <Controller
                            name="ngay_sinh"
                            control={control}
                            rules={{ required: "Vui lòng điền ngày sinh" }}
                            render={({ field }) => (
                                <StyledDatePicker
                                    selected={field.value ? new Date(field.value) : null}
                                    onChange={(date: Date | null) => {
                                        field.onChange(date);
                                        setFormData((prev) => ({
                                            ...prev,
                                            ngay_sinh: date,
                                        }));
                                    }}
                                    error={errors.ngay_sinh?.message}
                                />
                            )}
                        />
                    </FormControl>


                    <Controller
                        name="dm_gioitinh_id"
                        control={control}
                        rules={{ required: "Vui lòng chọn giới tính" }}
                        render={({ field }) => (
                            <>
                                <FormControl>
                                    <FormControl.Label>Giới tính</FormControl.Label>
                                    <ComboboxGioiTinh
                                        value={field.value}
                                        onValueChanged={(value) => {
                                            field.onChange(value);
                                            setFormData((prev) => ({
                                                ...prev,
                                                dm_gioitinh_id: value,
                                            }));
                                        }}
                                    />
                                    {errors.dm_gioitinh_id && (
                                        <FormControl.Validation variant="error">
                                            {errors.dm_gioitinh_id.message}
                                        </FormControl.Validation>
                                    )}
                                </FormControl>
                            </>

                        )}
                    />

                    <Controller
                        name="dm_quoctich_id"
                        control={control}
                        rules={{ required: "Vui lòng chọn quốc tịch" }}
                        render={({ field }) => (
                            <>
                                <FormControl>
                                    <FormControl.Label>Quốc tịch</FormControl.Label>
                                    <ComboboxQuocTich
                                        value={field.value}
                                        onValueChanged={(value) => {
                                            field.onChange(value);
                                            setFormData((prev) => ({
                                                ...prev,
                                                dm_quoctich_id: value,
                                            }));
                                        }}
                                    />
                                    {errors.dm_quoctich_id && (
                                        <FormControl.Validation variant="error">
                                            {errors.dm_quoctich_id.message}
                                        </FormControl.Validation>
                                    )}
                                </FormControl>
                            </>
                        )}
                    />
                    <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: "1fr 1fr" }}>
                        <Controller
                            name="dm_dantoc_id"
                            control={control}
                            rules={{ required: "Vui lòng chọn dân tộc" }}
                            render={({ field }) => (
                                <>
                                    <FormControl>
                                        <FormControl.Label>Dân tộc</FormControl.Label>
                                        <ComboboxDanToc
                                            value={field.value}
                                            onValueChanged={(value) => {
                                                field.onChange(value);
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    dm_dantoc_id: value,
                                                }));
                                            }}
                                        />
                                        {errors.dm_dantoc_id && (
                                            <FormControl.Validation variant="error">
                                                {errors.dm_dantoc_id.message}
                                            </FormControl.Validation>
                                        )}
                                    </FormControl>
                                </>
                            )}
                        />

                        <Controller
                            name="dm_tongiao_id"
                            control={control}
                            rules={{ required: "Vui lòng chọn tôn giáo" }}
                            render={({ field }) => (
                                <>
                                    <FormControl>
                                        <FormControl.Label>Tôn giáo</FormControl.Label>

                                        <ComboboxTonGiao
                                            value={field.value}
                                            onValueChanged={(value) => {
                                                field.onChange(value);
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    dm_tongiao_id: value,
                                                }));
                                            }}
                                        />
                                        {errors.dm_tongiao_id && (
                                            <FormControl.Validation variant="error">
                                                {errors.dm_tongiao_id.message}
                                            </FormControl.Validation>
                                        )}
                                    </FormControl>
                                </>
                            )}
                        />

                    </Box>




                </Box>
                <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: "repeat(4, 1fr)" }}>

                    <Controller
                        name="dm_trangthaihocsinh_id"
                        control={control}
                        rules={{ required: "Vui lòng chọn trạng thái học sinh" }}
                        render={({ field }) => (
                            <>
                                <FormControl>
                                    <FormControl.Label>Trạng thái học sinh</FormControl.Label>
                                    <ComboboxTrangThaiHocSinh
                                        value={field.value}
                                        onValueChanged={(value) => {
                                            field.onChange(value);
                                            setFormData((prev) => ({
                                                ...prev,
                                                dm_trangthaihocsinh_id: value,
                                            }));
                                        }}
                                    />
                                    {errors.dm_trangthaihocsinh_id && (
                                        <FormControl.Validation variant="error">
                                            {errors.dm_trangthaihocsinh_id.message}
                                        </FormControl.Validation>
                                    )}
                                </FormControl>
                            </>
                        )}
                    />

                    <Controller
                        name="nam_nhap_hoc"
                        control={control}
                        rules={{
                            required: "Vui lòng chọn năm nhập học",
                            validate: (value) => {
                                if (!value || !formData.nam_hoc) return true;
                                const namHoc = parseInt(
                                    formData.nam_hoc?.split(" - ")[0]
                                );
                                const namNhapHoc = parseInt(value?.split(" - ")[0]);
                                return (
                                    namHoc >= namNhapHoc ||
                                    "Năm nhập học phải nhỏ hơn hoặc bằng năm học"
                                );
                            },
                        }}
                        render={({ field }) => (
                            <>
                                <FormControl>
                                    <FormControl.Label>Năm nhập học</FormControl.Label>
                                    <ComboboxNamHoc
                                        value={field.value}
                                        onValueChanged={(value) => {
                                            field.onChange(value);
                                            setFormData((prev) => ({
                                                ...prev,
                                                nam_nhap_hoc: value,
                                            }));
                                            trigger("nam_nhap_hoc");
                                        }}
                                    />
                                    {errors.nam_nhap_hoc && (
                                        <FormControl.Validation variant="error">
                                            {errors.nam_nhap_hoc.message}
                                        </FormControl.Validation>
                                    )}
                                </FormControl>
                            </>
                        )}
                    />
                    <FormControl>
                        <FormControl.Label>Ngày nhập học</FormControl.Label>
                        <Controller
                            name="ngay_nhap_hoc"
                            control={control}
                            render={({ field }) => (
                                <StyledDatePicker
                                    selected={field.value ? new Date(field.value) : null}
                                    onChange={(date: Date | null) => {
                                        field.onChange(date);
                                        setFormData((prev) => ({
                                            ...prev,
                                            ngay_nhap_hoc: date,
                                        }));
                                    }}
                                    error={errors.ngay_nhap_hoc?.message}
                                />
                            )}
                        />
                    </FormControl>
                    {/* <FormControl>
                        <FormControl.Label>Là con thứ</FormControl.Label>
                        <TextInput
                            block
                            type="number"
                            name="laconthu"
                            register={register}
                            errors={errors}
                            // required
                            // validateMessage="Vui lòng điền thông tin"
                        />
                    </FormControl> */}



                </Box>
            </Box>
        </FormBlock>
    );
};

export default ThongTinHocSinh;